import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { defaultPaginationConfig } from '@spartacus/storefront';
import { I18nModule, provideDefaultConfig } from '@spartacus/core';
import { KbsSitePaginationComponent } from './kbs-site-pagination.component';



@NgModule({
  declarations: [KbsSitePaginationComponent],
  imports: [CommonModule, RouterModule, I18nModule],
  providers: [provideDefaultConfig(defaultPaginationConfig)],
  exports: [KbsSitePaginationComponent],
})
export class KbsSitePaginationModule { }
